module.exports = __webpack_public_path__ + "img/img_lianghua_ai@3x .131f5ae8.png";